import {
  FormControl,
  Select,
  MenuItem as SelectMenuItem,
} from "@material-ui/core";
import { useState } from "reactn";
import { Modal, Row, Col } from "react-bootstrap";
import Button from "components/button/button.component";

const ConfirmUnMarkBookingNoShowModal = ({
  show,
  onHide,
  booking,
  success = null,
  processing = false,
  error = null,
  onConfirm = (reason) => {},
  onBlurHide = false,
}) => {
  const [reason, setReason] = useState("");

  return (
    <div>
      ß
      <Modal
        className="center-modal"
        show={show}
        onHide={() => {
          if (onBlurHide) onHide();
        }}
        aria-labelledby="example-custom-modal-styling-title">
        <Modal.Header>
          <div className="font-500">Unmark booking as no-show</div>
        </Modal.Header>
        <Modal.Body className="scrollbar">
          <div>
            <div className="text-grey" style={{ marginTop: "-21px" }}>
              Do you want to unmark no-show for booking between{" "}
              <b>{booking?.mentor.name}</b> and <b>{booking?.mentee.name}</b>.
              If defaulted user is suspended, their account will be unsuspended.
              This action cannot be reversed.
            </div>

            <div className="mt-25">
              <div className="text-grey-light text-16 font-400 mb-10">
                Select reason to unmark
              </div>

              <FormControl fullWidth variant="outlined" className="mt-20">
                <Select
                  value={reason}
                  onChange={(event) => {
                    setReason(event.target.value);
                  }}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}>
                  <SelectMenuItem value="">Select one reason</SelectMenuItem>
                  <SelectMenuItem value="Marked accidentally">
                    Marked accidentally
                  </SelectMenuItem>
                  <SelectMenuItem value="At Customer’s request">
                    At Customer’s request
                  </SelectMenuItem>
                </Select>
              </FormControl>
            </div>

            {success && !processing && (
              <div className="mt-10 text-success text-center">{success}</div>
            )}

            {error && (!processing || !success) && (
              <div className="mt-10 text-danger text-center">{error}</div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="f-width">
            <Row>
              <Col xs={6}>
                <Button
                  classes="small info f-width"
                  disabled={processing}
                  onClick={onHide}>
                  {success ? "Close" : "Cancel"}
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  classes="small secondary f-width"
                  hidden={success}
                  loading={processing}
                  disabled={processing}
                  onClick={() => onConfirm(reason)}>
                  Confirm
                </Button>
              </Col>
            </Row>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ConfirmUnMarkBookingNoShowModal;
